import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { useCallback } from 'react';
import { STOMP_WS_ENABLED } from '@/config/stomp-ws';
import { useToastContext } from '@/layout/context/toast-context';
import { clearActiveBreak } from '@/shared/auth/auth.reducer';
import { useBreakUserTopicSubscription } from '@/shared/hooks/useBreakUserTopicSubscription';
import { useAppDispatch, useAppSelector } from '@/store';
/**
 * Listens for supervisor force-return events on `/topic/break.user.{username}` and clears break UI state.
 */
export function BreakEventsProvider({ children }) {
    const dispatch = useAppDispatch();
    const { showToast } = useToastContext();
    const session = useAppSelector((state) => state.auth.session);
    const username = session?.username?.trim() ?? '';
    const onBreakEnded = useCallback((detail) => {
        dispatch(clearActiveBreak());
        const by = detail.endedBy?.trim();
        showToast({
            severity: 'info',
            summary: 'Returned to service',
            detail: by
                ? `Your break was ended by supervisor ${by}. You are available for calls again.`
                : 'Your break was ended by a supervisor. You are available for calls again.',
            life: 6000,
        });
    }, [dispatch, showToast]);
    useBreakUserTopicSubscription({
        username,
        enabled: STOMP_WS_ENABLED && Boolean(username),
        onBreakEnded,
    });
    return _jsx(_Fragment, { children: children });
}
